import { c as _c } from "react/compiler-runtime";
import { EMAIL_STATISTICS_API } from 'modules/email-statistics/api/email-statistics-api';
import { EmailStatisticsPoolInterface } from 'modules/email-statistics/types/email-statistics-interface';
import useUser from 'shared/hooks/use-user';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
export const useEmailStatisticsPool = () => {
  const $ = _c(2);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] !== user) {
    t0 = () => {
      if (!user) {
        return;
      }
      return `${EMAIL_STATISTICS_API}/pool-data`;
    };
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useSWR(t0, baseFetcher);
};